import React from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import Select from "../../form/Select";
import {PercentFormatter} from '../../../utils/formatters.js';

const getControls = (props) => ({
    id: <TextInput
        name={props.componentConfig.idfield}
        value={props.values[props.componentConfig.idfield]}
        label="Kód"
        role="idfield"
        {...props.getFieldProps(props.componentConfig.idfield)}
    />,
    seller: <Select
        objectValue={true}
        name="seller"
        value={props.values.seller}
        labelKey="name"
        valueKey="partner_id"
        component="partner"
        storeType="remote"
        saveChanges={props.setFieldValue}
        label="Partner"
        {...props.getFieldProps("seller")}
    />,
    customer: <Select
        objectValue={true}
        name="customer"
        value={props.values.customer}
        labelKey="name"
        valueKey="partner_id"
        component="partner"
        storeType="remote"
        saveChanges={props.setFieldValue}
        label="Partner"
        {...props.getFieldProps("customer")}
    />,
    billingdays: <TextInput
        name="billingdays"
        value={props.values.billingdays}
        label="Számlázási napok"
        saveChanges={props.setFieldValue}
        {...props.getFieldProps("billingdays")}
    />,
    purchase_discount: <TextInput
        name="purchase_discount"
        value={props.values.purchase_discount ? props.values.purchase_discount * 100 : 0}
        label="Fix kedvezmény"
        formatter={PercentFormatter}
        saveChanges={(f, v) => props.setFieldValue(f, (v/100))}
        {...props.getFieldProps("purchase_discount")}
    />,
    consignment_discount: <TextInput
        name="consignment_discount"
        value={props.values.consignment_discount ? props.values.consignment_discount * 100 : 0}
        label="Bizományi kedvezmény"
        formatter={PercentFormatter}
        saveChanges={(f, v) => props.setFieldValue(f, (v/100))}
        {...props.getFieldProps("consignment_discount")}
    />
})

export const PartnerCommercialContractForm = createForm((props) => {
    const controls = getControls(props);
    return(<form onSubmit={props.handleSubmit}>
        <div className="row form-row">
            <div className="col-md-4">
                {controls.billingdays}
            </div>
            <div className="col-md-4">
                {controls.purchase_discount}
            </div>
            <div className="col-md-4">
                {controls.consignment_discount}
            </div>
        </div>
    </form>);
});

export default createForm((props) => {
    const controls = getControls(props);
    return(
        <form onSubmit={props.handleSubmit}>
            <div className="row form-row">
                <div className="col-md-4">
                    {controls.id}
                </div>
                <div className="col-md-4">
                    {controls.seller}
                </div>
                <div className="col-md-4">
                    {controls.customer}
                </div>
            </div>
            <div className="row form-row">
                <div className="col-md-4">
                    {controls.billingdays}
                </div>
                <div className="col-md-4">
                    {controls.purchase_discount}
                </div>
                <div className="col-md-4">
                    {controls.consignment_discount}
                </div>
            </div>
        </form>
    );
});
